import { readonly } from 'vue'
import { AppVisibility } from './app-visibility.js'

const appVisibility = new AppVisibility()

const initAppVisibility = () => appVisibility.init()

const destroyAppVisibility = () => appVisibility.destroy()

export const useAppVisibility = () => {
  return {
    appIsVisible: readonly(appVisibility.isVisible),
    initAppVisibility,
    destroyAppVisibility,
  }
}
